module.exports = "<div class=\"error-toast\" *ngIf=\"error$ | async as error\">\n  <div class=\"toast-box\">\n    <div class=\"toast-content\">\n      {{ error.message }}\n    </div>\n    <a class=\"toast-close\" (click)=\"closeAlert()\" aria-label=\"close\">&times;</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/error-toast/error-toast.component.html
// module id = ./src/app/shared/error-toast/error-toast.component.html
// module chunks = main